<template>
  <div class="create-compliance-container">
    <Alert :message="alert.message" :type="alert.type" :show="alert.show" />

    <b-modal
        id="complianceDetailsModal"
        hide-footer
        hide-header
        size="md"
        :scrollable="false"
        ref="complianceDetailsModal"
      >
      <ComplianceDetailsModal :previewData="previewData" />
    </b-modal>

        <b-modal
        id="changeComplianceFormatModal"
        hide-footer
        hide-header
        size="md"
        :scrollable="false"
        ref="changeComplianceFormatModal"
      >
      <ChangeComplianceFormatModal />
    </b-modal>

    <section id="createCompliance">
      <b-form @submit.prevent="onSubmit">
        <VpFormLayout :formData="form">
          <template v-slot:content-header="{ form }">
            <PageHeader className="d-flex align-items-center" :title="$route.name == 'createCompliance' ? $t('complianceList.createCompliance') : $t('complianceList.form.editCompliance')" />
          </template>
          
          <template v-slot:content-body="{ form }">
            <div class="form-width">
              <!-- Name -->
              <b-form-group
                class="text-muted"
                id="name-group"
                :label="$t('complianceList.form.complianceName')"
                label-for="name"
              >
                <b-form-input
                  maxlength="50"
                  id="name"
                  :placeholder="$t('complianceList.form.enterComplianceName')"
                  v-model="form.name"
                  type="text"
                  :class="{
                    'is-invalid': submitted && $v.form.name.$error,
                    'cursor-not-allowed':$v.form.name.$model.length >=50
                  }"
                />
                <div
                  v-if="submitted && $v.form.name.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.name.required">{{ $t('common.validation.nameIsRequired') }}</span>
                  <span v-else-if="!$v.form.name.minLength"
                    >{{ $t('complianceList.form.nameShould2CharactersAtLeast') }}</span
                  >
                  <span v-else-if="!$v.form.name.maxLength"
                    >{{ $t('common.validation.theMaximumLengthIs') }}
                    {{ $v.form.name.$params.maxLength.max }} {{ $t('common.validation.characters') }}</span
                  >
                </div>
              </b-form-group>
              <!-- Type -->
              <b-form-group class="text-muted" :label="$t('common.type')" label-for="type">
                <multiselect
                  id="type"
                  v-model="form.type"
                  :options="typeOptions"
                  :placeholder="$t('common.selectType')" 
                  :show-labels="false"
                  :allowEmpty="true"
                  label="name"
                  track-by="id"
                  @input="changeComplianceType(form.type)"
                >
                  <!-- <template slot="option" slot-scope="props">
                    <div class="option__desc">
                      <span> {{ props.option }}</span>
                    </div>
                  </template> -->
                </multiselect>
              </b-form-group>

              <div v-if="form.type">
                <div v-if="form.type.id === 'agreement' || form.type.id === 'questionnaire'" class="desired-answer-container">

                  <!-- question -->
                  <b-form-group 
                    v-if="form.type.id === 'questionnaire'"
                    class="text-muted"
                    id="question-group"
                    :label="$t('complianceList.form.question')"
                    label-for="questionInput"
                  >
                    <b-form-input
                      id="questionInput"
                      v-model="form.questionInput"
                      :placeholder="$t('complianceList.form.enterYourQuestion')"
                      :maxlength="2001"
                      type="text"
                      :class="{
                        'is-invalid': submitted && $v.form.questionInput.$error,
                      }"
                    >
                    </b-form-input>
                    <div
                      v-if="submitted && $v.form.questionInput.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.questionInput.required"
                        >{{ $t('complianceList.form.questionIsRequired') }}</span
                      >
                      <span v-if="!$v.form.questionInput.minLength"
                        >{{ $t('common.validation.theMinimumLengthIs') }}
                        {{
                          $v.form.questionInput.$params.minLength.min
                        }}
                        {{ $t('common.validation.characters') }}</span
                      >
                      <span v-if="!$v.form.questionInput.maxLength"
                        >{{ $t('common.validation.theMaximumLengthIs') }}
                        {{
                          $v.form.questionInput.$params.maxLength.max
                        }}
                        {{ $t('common.validation.characters') }}</span
                      >
                    </div>
                  </b-form-group>

                  <!-- agreement -->
                   <div v-if="form.type.id === 'agreement'">
                    <span class="agreement-format-title text-muted vp-mb-24">{{ $t('complianceList.form.agreementFormat') }}</span>

                    <!-- <v-radio-group v-model="form.agreementFormat" class="col-12 d-flex"
                    
                    @input="changeAgreementFormatVal(form.agreementFormat)"
                    >

                      <b-radio class="vp-mb-24 col-6 col-md-6 col-sm-12" key="text_manually" value="text_manually">
                        {{$t('complianceList.form.enterTextManually')}}</b-radio>

                      <div class="col-6">
                        <v-radio class="col-12 col-md-6 col-sm-12" key="upload_file" value="upload_file">
                          {{ $t('common.notes.uploadFilePdfOrImage') }}</v-radio>

                      </div>

                    </v-radio-group> -->

                    <v-radio-group class="col-12 d-flex vp-pl-0"
                    v-model="form.agreementFormat"
                    @change="changeAgreementFormatVal(form.agreementFormat)"
                  >
                    <v-radio
                     
                      :key="agreementFormatsOptions[0].value"
                      :label="agreementFormatsOptions[0].text"
                      :value="agreementFormatsOptions[0].value"
                      class="col-lg-6 col-md-6 col-sm-12 vp-pl-0"
                    ></v-radio>

                    <div class="col-6 vp-pt-0">
                    <v-radio
                      :key="agreementFormatsOptions[1].value"
                      :label="agreementFormatsOptions[1].text"
                      :value="agreementFormatsOptions[1].value"
    
                    ></v-radio>
                    <div class="vp-ml-37 vp-width-380 vp-pl-0 upload-file-note"><b>{{ $t('common.notes.note') }}: </b>{{ $t('complianceList.form.pdfAndImageAgreementsUsedJourneysTouchModeEnabled') }}</div>
                    </div>
                  </v-radio-group>

                  </div>
                  <!-- agreement  -->
                  <b-form-group
                    v-if="form.type.id === 'agreement' && form.agreementFormat === 'text_manually'"
                    class="text-muted"
                    :label="$t('complianceList.form.agreementText')"
                    label-for="agreement-txt"
                  >
                    <b-form-textarea
                      id="agreement-txt"
                      :placeholder="$t('complianceList.form.enterYourAgreement')"
                      v-model="form.agreementTxt"
                      type="text"
                      :class="{
                        'is-invalid': submitted && $v.form.agreementTxt.$error,
                      }"
                    >
                    </b-form-textarea>
                    <div
                      v-if="submitted && $v.form.agreementTxt.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.agreementTxt.required"
                        >{{ $t('complianceList.form.agreementTextIsRequired') }}</span
                      >
                      <span v-if="!$v.form.agreementTxt.minLength"
                        >{{ $t('common.validation.theMinimumLengthIs') }}
                        {{
                          $v.form.agreementTxt.$params.minLength.min
                        }}
                        {{ $t('common.validation.characters') }}</span
                      >
                      <!-- <span v-if="!$v.form.agreementTxt.maxLength"
                        >The Maximum length is {{ $v.form.agreementTxt.$params.maxLength.max }} characters</span
                      > -->
                    </div>
                  </b-form-group>

                  <div v-if="form.type.id === 'agreement' && form.agreementFormat === 'upload_file'" class="vp-mb-16">
                    <!-- <div class="upload-file-compliance"> -->

                    <!-- <b-file @change="uploadFile($event)" type="file" accept=".pdf, .jpg, .jpeg, .png" class="vp-mb-8 " ref="fileRefName"
                    :placeholder="$t('common.noFileChosen')" /> -->
                                            
                    <div class="d-flex align-items-center vp-mb-8">
                    
                      <div for="file-upload">
                        <input id="file-upload" @change="uploadFile($event)" type="file" accept=".pdf, .jpg, .jpeg, .png" class="vp-mb-8 d-none" ref="fileRefName"
                          :placeholder="$t('common.noFileChosen')"/>
                        <button @click="triggerFileInput" type="button" class="no-file-choosen-btn">{{ $t('common.chooseFile') }}</button>
                        <label for="file-upload" class="no-file-choosen-text">{{  form.fileName ? form.fileName :  $t('common.noFileChosen') }}</label>
                      </div>
                      
                    </div>

                    <!-- </div> -->


                    <div class="vp-mb-16">
                      <span v-if="!uploadFileError" class="upload-file-text" ><b>{{ $t('common.notes.note') }}:</b> {{ $t('common.notes.uploadedFileShouldBePdfImageWithMaxSize2MB') }}</span>
                      <span v-if="uploadFileError || (!$v.form.attachment_url.required && submitted)" class="upload-file-error" >{{ $t('common.notes.uploadedFileShouldBePdfImageWithMaxSize2MB') }}</span>
                      </div>

                    <div v-if="!uploadFileError">

                      <div v-if="form.content_type === 'PDF'" class="d-flex">
                        <img @click="showPdfFilePreview()" src="@/assets/images/pdf-icon.png" class="cursor-pointer pdf-icon" :alt="form.fileName"/>
                        <svg @click="removeFile()" width="16" height="16" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" class="remove-pdf-times"><path d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z" fill="#F46A6A"></path></svg>
                      </div>

                      <div v-if="form.content_type === 'IMAGE'" class="d-flex">
                        <img v-viewer :src="form.filePreviewUrl" class="cursor-pointer thumbnail-image" :alt="form.fileName"/>
                        <svg @click="removeFile()" width="16" height="16" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" class="remove-image-times"><path d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z" fill="#F46A6A"></path></svg>
                      </div>
                    </div>

                  </div>


                  <!-- desired answers -->
                  <h5 class="comp-subtitle text-muted">{{ $t('complianceList.form.desiredAnswer') }}:</h5>
                  <!-- Yes -->
                  <div class="quiz-container flex-row">
                    <b-form-checkbox
                      class="comp-checkbox"
                      v-model="form.yesChecked"
                    />
                    <div class="comp-input-container">
                      <label for="yesStatement">{{ $t('complianceList.form.positiveAnswer') }}</label>
                      <b-form-input
                        class="compliance-custom-input"
                        v-model="form.yesStatement"
                        id="yesStatement"
                        :placeholder="$t('complianceList.form.statement')"
                        :maxlength="28"
                        :class="{
                          'is-invalid':
                            submitted && $v.form.yesStatement.$error,
                        }"
                      />
                      <div
                        v-if="submitted && $v.form.yesStatement.$error"
                        class="invalid-feedback"
                      >
                        <span
                          style="font-size: 0.8rem"
                          v-if="!$v.form.yesStatement.required"
                          >{{ $t('complianceList.form.statementTextIsRequired') }}</span
                        >
                        <span
                          style="font-size: 0.8rem"
                          v-if="!$v.form.yesStatement.maxLength"
                        >
                        {{ $t('common.validation.theMaximumLengthIs') }}
                          {{
                            $v.form.yesStatement.$params.maxLength.max
                          }}{{ $t('common.validation.characters') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <!-- No -->
                  <div class="quiz-container flex-row">
                    <b-form-checkbox
                      class="comp-checkbox"
                      v-model="form.noChecked"
                    />
                    <div class="comp-input-container">
                      <label for="noStatement">{{ $t('complianceList.form.negativeAnswer') }}</label>
                      <b-form-input
                        class="compliance-custom-input"
                        v-model="form.noStatement"
                        id="noStatement"
                        :placeholder="$t('complianceList.form.statement')"
                        :maxlength="28"
                        :class="{
                          'is-invalid': submitted && $v.form.noStatement.$error,
                        }"
                      />
                      <div
                        v-if="submitted && $v.form.noStatement.$error"
                        class="invalid-feedback"
                      >
                        <span
                          style="font-size: 0.8rem"
                          v-if="!$v.form.noStatement.required"
                          >{{ $t('complianceList.form.statementTextIsRequired') }}</span
                        >
                        <span
                          style="font-size: 0.8rem"
                          v-if="!$v.form.noStatement.maxLength"
                        >
                        {{ $t('common.validation.theMaximumLengthIs') }}
                          {{
                            $v.form.noStatement.$params.maxLength.max
                          }}
                          {{ $t('common.validation.characters') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <p
                    class="text-danger mt-4 err-font border-top border-bottom py-2"
                    v-if="!form.yesChecked && !form.noChecked"
                  >
                  {{ $t('complianceList.form.atLeastOneAnswerShouldBeChecked')}}
                  </p>
                  <transition-group name="fade" mode="out-in">
                    <li v-for="(el, index) in answers" :key="index">
                      <AddedQuestion
                        :element="el"
                        :index="index"
                        :deleteQuestion="deleteQuestion"
                        :type="form.type.id"
                        :submitted="submitted"
                        :setAddedQuestioinsErr="setAddedQuestioinsErr"
                      />
                    </li>
                  </transition-group>
                  <div class="text-danger mt-3" v-if="showErr">
                    <p class="err-font">{{ $t('complianceList.form.fieldsAboveFilledFirst')}} </p>
                  </div>
                  <div
                    v-if="answers.length < questionsLimit"
                    class="quiz-btns-box"
                  >
                    <button
                      @click.prevent="onQuestionsSubmission"
                      v-if="form.type.id === 'questionnaire'"
                    >
                      {{ $t('complianceList.form.addQuestion') }}
                    </button>
                  </div>
                </div>
                <!-- vaccine -->
                <div v-else class="desired-answer-container">
                  <h5 class="comp-subtitle text-muted">{{ $t('complianceList.form.desiredOutcomes')}}</h5>
                  <!-- uploaded -->
                  <div class="quiz-container flex-row">
                    <b-form-checkbox
                      class="comp-checkbox"
                      v-model="form.yesChecked"
                      disabled
                    >
                    {{ $t('complianceList.form.documentUploaded')}}
                    </b-form-checkbox>
                    <div class="comp-input-container w-75">
                      <b-form-input
                        class="compliance-custom-input"
                        v-model="vaccine.uploadedStatement"
                        id="yesStatement"
                        :placeholder="$t('complianceList.form.statement')"
                        :class="{
                          'is-invalid':
                            submitted && $v.vaccine.uploadedStatement.$error,
                        }"
                      />
                      <div
                        v-if="submitted && $v.vaccine.uploadedStatement.$error"
                        class="invalid-feedback"
                      >
                        <span
                          style="font-size: 0.8rem"
                          v-if="!$v.vaccine.uploadedStatement.required"
                          >{{ $t('complianceList.form.statementTextIsRequired') }}</span
                        >
                        <span
                          style="font-size: 0.8rem"
                          v-if="!$v.vaccine.uploadedStatement.maxLength"
                        >
                        {{ $t('common.validation.theMaximumLengthIs') }}
                          {{
                            $v.vaccine.uploadedStatement.$params.maxLength.max
                          }}
                          {{ $t('common.validation.characters') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <!-- not uploaded -->
                  <div class="quiz-container flex-row">
                    <b-form-checkbox
                      class="comp-checkbox"
                      v-model="form.noChecked"
                    >
                    {{ $t('complianceList.form.documentNotUploaded')}}
                    </b-form-checkbox>
                    <div class="comp-input-container w-75">
                      <b-form-input
                        class="compliance-custom-input"
                        v-model="vaccine.notUploadedStatement"
                        id="noStatement"
                        :placeholder="$t('complianceList.form.statement')"
                        :class="{
                          'is-invalid':
                            submitted && $v.vaccine.notUploadedStatement.$error,
                        }"
                      />
                      <div
                        v-if="
                          submitted && $v.vaccine.notUploadedStatement.$error
                        "
                        class="invalid-feedback"
                      >
                        <span
                          style="font-size: 0.8rem"
                          v-if="!$v.vaccine.notUploadedStatement.required"
                          >{{ $t('complianceList.form.statementTextIsRequired') }}</span
                        >
                        <span
                          style="font-size: 0.8rem"
                          v-if="!$v.vaccine.notUploadedStatement.maxLength"
                        >
                        {{ $t('common.validation.theMaximumLengthIs') }}
                          {{
                            $v.vaccine.notUploadedStatement.$params.maxLength
                              .max
                          }}
                          {{ $t('common.validation.characters') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="
                      form.yesChecked == false &&
                      form.noChecked == false
                    "
                    style="
                      width: 100%;
                      margin-top: 0.25rem;
                      font-size: 80%;
                      color: #f46a6a;
                    "
                  >
                    <span> *{{ $t('complianceList.form.shouldSelectOneAtLeast')}} </span>
                  </div>
                  <div class="text-danger text-center mt-3" v-if="showErr">
                    <p>{{ $t('complianceList.form.fieldsAboveFilledFirst')}}</p>
                  </div>
                  <div class="settings mt-4">
                    <!-- protocols  -->
                    <b-form-group
                      class="align-items-center"
                      label-cols-sm="4"
                      label-cols-lg="3"
                      :label="Protocols"
                      label-for="$t('complianceList.form.protocols')"
                    >
                      <multiselect
                        id="protocols"
                        :class="{
                          'is-invalid invalid-select-input protocols-multiselect':
                            submitted && $v.vaccine.protocols.$error,
                        }"
                        v-model="vaccine.protocols"
                        :options="protocolsOptions"
                        :placeholder="$t('complianceList.form.selectProtocols')"
                        :show-labels="false"
                        :allowEmpty="true"
                        multiple
                      />
                      <div
                        v-if="submitted && $v.vaccine.protocols.$error"
                        class="invalid-feedback"
                      >
                        <span
                          style="font-size: 0.8rem"
                          v-if="!$v.vaccine.protocols.required"
                          >{{ $t('complianceList.form.atLeaseOneProtocolSelected') }}</span
                        >
                      </div>
                    </b-form-group>
                    <!-- document_binding -->
                    <b-form-group
                      class="align-items-center bindingTo"
                      label-cols-sm="4"
                      label-cols-lg="3"
                      :label="$t('complianceList.form.documentBindingTo')"
                      label-for="questionInput"
                    >
                      <div class="d-flex align-items-center">
                        <b-form-radio
                          v-model="vaccine.document_binding"
                          value="profile"
                        />
                        <span>{{ $t('complianceList.form.userProfile') }}</span>
                      </div>
                    </b-form-group>
                    <!-- pcr  -->
                    <b-form-group
                      label-cols-sm="5"
                      label-cols-md="4"
                      label-cols-lg="3"
                      :label="$t('complianceList.form.acceptNegativePCR')"
                      label-for="mask"
                      class="align-items-center input-wrapper no-wrap"
                    >
                      <b-form-checkbox
                        switch
                        size="lg"
                        v-model="vaccine.pcr"
                      ></b-form-checkbox>
                    </b-form-group>
                    <!-- validation days  -->
                    <b-form-group
                      v-if="vaccine.pcr"
                      :label="$t('complianceList.form.pcrValidDays')"
                      label-cols-sm="4"
                      label-cols-lg="3"
                      class="gap-10"
                    >
                      <b-input
                        id="questionInput"
                        v-model="vaccine.validationDays"
                        :placeholder="$t('complianceList.form.enterNumberOfDays')"
                        type="number"
                        :class="{
                          'is-invalid':
                            submitted && $v.vaccine.validationDays.$error,
                        }"
                        max="365"
                      >
                      </b-input>
                      <div
                        v-if="submitted && $v.vaccine.validationDays.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.vaccine.validationDays.required"
                          >{{ $t('complianceList.form.validationDaysNumberIsRequired') }}</span
                        >
                      </div>
                      <div
                        v-if="submitted && $v.vaccine.validationDays.$error"
                        class="invalid-feedback"
                      >
                        <span v-if="!$v.vaccine.validationDays.maxLength"
                          >{{ $t('complianceList.form.validationDaysShouldBe3Digits') }}</span
                        >
                      </div>
                      <div
                        v-if="submitted && !$v.vaccine.validationDays.numeric"
                        class="invalid-feedback"
                      >
                        <span>{{ $t('complianceList.form.validationDaysShouldBeNumber') }}</span>
                      </div>
                    </b-form-group>
                  </div>
                </div>
                
              </div>
            </div>  
          </template>

          <template v-slot:content-footer="{ form }">
            <VpButton
            :text="$route.name == 'updateCompliance' ? $t('common.update') : $t('common.create')"
            :disabled="getLoading || $v.form.$invalid" type="submit"
            :isLoading="getLoading" :height="'37px'" :width="'151px'" />
          </template>
        </VpFormLayout>
      </b-form>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import {
  required,
  requiredIf,
  minLength,
  maxLength,
  numeric,
} from "vuelidate/lib/validators";
import Alert from "@/components/sharedCells/alert";
import PageHeader from "@/components/page-header.vue";
import store from "@/state/store";
import AddedQuestion from "./AddedQuestion";
import Multiselect from "vue-multiselect";
import ComplianceDetailsModal from "./ComplianceDetailsModal";
import ChangeComplianceFormatModal from "./ChangeComplianceFormatModal";

export default {
  name: "CreateCompliance",
  title: "Compliance Form",
  components: {
    Alert,
    AddedQuestion,
    Multiselect,
    PageHeader,
    ComplianceDetailsModal,
    ChangeComplianceFormatModal
  },
  data: function () {
    return {
      form: {
        name: "",
        type: null,
        agreementTxt: "",
        questionInput: "",
        noStatement: "",
        yesStatement: "",
        noChecked: false,
        yesChecked: true,
        agreementFormat: "text_manually",
        content_type: "TEXT",
        attachment_url: "",
        fileName: "",
        filePreviewUrl: "",
      },
      vaccine: {
        document_binding: "profile",
        pcr: false,
        validationDays: null,
        uploadedStatement: this.$t("dashboard.grid.vaccineOptions.vaccinated"),
        notUploadedStatement: this.$t("dashboard.grid.vaccineOptions.unchecked"),
        protocols: null,
      },
      answers: [],
      questionsLimit: 14,
      typeOptions: [
        { name: this.$t("common.questionnaire"), id :"questionnaire"}, { name : this.$t("common.agreement"), id : "agreement"}, 
        { name : this.$t("common.documentVaccinePcr"), id : "vaccine_document"}],
      protocolsOptions: [
        this.$t("complianceList.form.eu"),
        this.$t("complianceList.form.nhs"),
        this.$t("complianceList.form.smart"),
        this.$t("complianceList.form.nys"),
      ],
      submitted: false,
      showErr: false,
      addedQuestioinsErr: false,
      agreementFormatsOptions: [
        { value: 'text_manually', text: this.$t('complianceList.form.enterTextManually') },
        { value: 'upload_file', text: this.$t('common.notes.uploadFilePdfOrImage') },
      ],
      pdfFileVal: "@/assets/images/pdf-icon.png",
      uploadFileError: false,
      validTypesFiles : ['application/pdf', 'image/png', 'image/jpeg'],
      previewData: null,
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(50),
      },
      agreementTxt: {
        required: requiredIf(function (form) {
          return form.content_type == "TEXT" && form.type.id === "agreement";
        }),
        minLength: minLength(5),
        // maxLength: maxLength(2000),
      },
      questionInput: {
        required: requiredIf(function (form) {
          return form.type.id === "questionnaire";
        }),
        minLength: minLength(5),
        maxLength: maxLength(2000),
      },
      yesStatement: {
        required: requiredIf(function (form) {
          return form.type.id === "questionnaire" || form.type.id === "agreement";
        }),
        maxLength: maxLength(27),
      },
      noStatement: {
        required: requiredIf(function (form) {
          return form.type.id === "questionnaire" || form.type.id === "agreement";
        }),
        maxLength: maxLength(27),
      },
      attachment_url: {
        required: requiredIf(function (form) {
          return form.agreementFormat == "upload_file";
        }),
      },
    },
    vaccine: {
      validationDays: {
        required: requiredIf(function (vaccine) {
          return vaccine.pcr;
        }),
        numeric,
        maxLength: maxLength(3),
      },
      uploadedStatement: {
        required: requiredIf(function () {
          return (
            this.form.type.id !== "questionnaire" && this.form.type.id !== "agreement"
          );
        }),
        maxLength: maxLength(27),
      },
      notUploadedStatement: {
        required: requiredIf(function () {
          return (
            this.form.type.id !== "questionnaire" && this.form.type.id !== "agreement"
          );
        }),
        maxLength: maxLength(27),
      },
      protocols: {
        required: requiredIf(function () {
          return (
            this.form.type.id !== "questionnaire" && this.form.type.id !== "agreement"
          );
        }),
      },
    },
  },
  computed: {
    ...mapGetters("compliance", ["getLoading", "getComplianceDetails"]),
    alert() {
      return {
        message: store.state.notification.message,
        type: store.state.notification.type,
        show: store.state.notification.show,
      };
    },
    printProtocolsArr() {
      const {
        vaccine: { protocols },
      } = this;
      return protocols
        ? protocols.map((protocol) => {
            switch (protocol) {
              case "EU Digital COVID Certificate":
                return "eu";
              case "NHS (Domestic/International)":
                return "nhs";
              case "Smart Health Card (SHC)":
                return "shc";
              case "NYS Excelsior Pass & NYS Excelsior Pass Plus":
                return "nys";
              default:
                return;
            }
          })
        : null;
    },
  },
  watch: {
    getComplianceDetails(details) {
      // console.log('details', details);
      if(details.type == "questionnaire") {
          this.form.type = { name: "Questionnaire", id :"questionnaire"};
        }else if(details.type == "agreement") {
          this.form.type = { name : "Agreement", id : "agreement"};
        }else{
          this.form.type = { name : "Document - Vaccine/PCR", id : "vaccine_document"}
        }
        // console.log('this.form.type', this.form.type);
      if (details.form_metadata && details.form_metadata.data) {
        (this.form.name = details.name),
          details.form_metadata.data.length > 0 &&
            details.form_metadata.data.map((item) => {
              // console.log('item', item);
              // (this.form.type.id = item.type == "vaccine_document" ? "Document - Vaccine/PCR" : item.type),
                this.form.type.id == "agreement" ? (this.form.agreementTxt = item.body) : (this.form.questionInput = item.body),
                (this.form.agreementTxt = details.form_metadata.data[0].body);
              this.form.questionInput = details.form_metadata.data[0].body;
              if (details.type == "vaccine_document") {
                this.vaccine.uploadedStatement =
                  details.form_metadata.data[0].answers[0].text;
                this.vaccine.notUploadedStatement =
                  details.form_metadata.data[0].answers[1].text;
                this.form.yesChecked =
                  details.form_metadata.data[0].answers[0].desired;
                this.form.noChecked =
                  details.form_metadata.data[0].answers[1].desired;
                this.vaccine.protocols = this.getProtocolsValueOnUpdate(
                  details.form_metadata.data[0].protocols
                );
              } else {
                this.form.yesStatement =
                  details.form_metadata.data[0].answers[0].text;
                this.form.noStatement =
                  details.form_metadata.data[0].answers[1].text;
                this.form.yesChecked =
                  details.form_metadata.data[0].answers[0].desired;
                this.form.noChecked =
                  details.form_metadata.data[0].answers[1].desired;
              }
              // handle vaccine update
              if (details.form_metadata.data[0].pcr) {
                this.vaccine.pcr = true;
                this.vaccine.validationDays =
                  details.form_metadata.data[0].pcr.days;
              }
            });
        if (details.form_metadata.data.length > 1) {
          for (
            let index = 1;
            index < details.form_metadata.data.length;
            index++
          ) {
            this.onQuestionsSubmission();
            this.answers[index - 1][0].question =
              details.form_metadata.data[index].body;
            this.answers[index - 1][1].text =
              details.form_metadata.data[index].answers[0].text;
            this.answers[index - 1][1].desired =
              details.form_metadata.data[index].answers[0].desired;
            this.answers[index - 1][2].text =
              details.form_metadata.data[index].answers[1].text;
            this.answers[index - 1][2].desired =
              details.form_metadata.data[index].answers[1].desired;
          }
        }
      } else if (details && details.form_metadata && details.form_metadata.questions) {
        // details.form_metadata.questions = JSON.parse(details.form_metadata.questions); 
        (this.form.name = details.name),
          details.form_metadata.questions.length > 0 &&
            details.form_metadata.questions.map((item) => {
              // (this.form.type =
              //   item.type == "vaccine_document"
              //     ? "Document - Vaccine/PCR"
              //     : item.type),
                this.form.type.id == "agreement"
                  ? (this.form.agreementTxt = item.body)
                  : (this.form.questionInput = item.body),
                (this.form.agreementTxt =
                  details.form_metadata.questions[0].body);
                (this.form.content_type = details.form_metadata.questions[0].content_type);
                (this.form.attachment_url = details.form_metadata.questions[0].attachment_url);

                if (this.form.content_type == "PDF" || this.form.content_type == "IMAGE") {
                  this.form.agreementFormat = "upload_file";
                  this.form.filePreviewUrl = details.form_metadata.questions[0].attachment_url;
                }else{
                  this.form.agreementFormat = "text_manually";
                }

              console.log('attachment_urllll', this.form.attachment_url);
              console.log('content_typeeee', this.form.content_type);

              this.form.questionInput = details.form_metadata.questions[0].body;
              if (details.type == "vaccine_document") {
                this.vaccine.uploadedStatement =
                  details.form_metadata.questions[0].answers[0].text;
                this.vaccine.notUploadedStatement =
                  details.form_metadata.questions[0].answers[1].text;
                this.form.yesChecked =
                  details.form_metadata.questions[0].answers[0].desired;
                this.form.noChecked =
                  details.form_metadata.questions[0].answers[1].desired;
                this.vaccine.protocols = this.getProtocolsValueOnUpdate(
                  details.form_metadata.questions[0].protocols
                );
              } else {
                this.form.yesStatement =
                  details.form_metadata.questions[0].answers[0].text;
                this.form.noStatement =
                  details.form_metadata.questions[0].answers[1].text;
                this.form.yesChecked =
                  details.form_metadata.questions[0].answers[0].desired;
                this.form.noChecked =
                  details.form_metadata.questions[0].answers[1].desired;
              }
              // handle vaccine update
              if (details.form_metadata.questions[0].pcr) {
                this.vaccine.pcr = true;
                this.vaccine.validationDays =
                  details.form_metadata.questions[0].pcr.days;
              }
            });
        if (details.form_metadata.questions.length > 1) {
          for (
            let index = 1;
            index < details.form_metadata.questions.length;
            index++
          ) {
            this.onQuestionsSubmission();
            this.answers[index - 1][0].question =
              details.form_metadata.questions[index].body;
            this.answers[index - 1][1].text =
              details.form_metadata.questions[index].answers[0].text;
            this.answers[index - 1][1].desired =
              details.form_metadata.questions[index].answers[0].desired;
            this.answers[index - 1][2].text =
              details.form_metadata.questions[index].answers[1].text;
            this.answers[index - 1][2].desired =
              details.form_metadata.questions[index].answers[1].desired;
          }
        }
      }
    },
    answers(answers) {
      if (answers.length == 0) {
        this.addedQuestioinsErr = false;
      }
    },
  },
  methods: {
    ...mapActions("compliance", [
      "createCompliance",
      "updateComplianceAction",
      "complianceDetails",
      "canChangeComplianceFormat"
    ]),
    onQuestionsSubmission() {
      if (
        this.form.yesStatement &&
        this.form.noStatement &&
        !this.addedQuestioinsErr
      ) {
        let quizObject = [
          { question: null },
          {
            desired: true,
            text: "",
            yesAnswer: true,
          },
          {
            desired: false,
            text: "",
            yesAnswer: false,
          },
        ];
        this.writtenQuestions(quizObject);
        this.showErr = false;
      } else {
        this.showErr = true;
      }
    },
    handleComplianceType() {
      switch (this.form.type.id) {
        case "questionnaire":
          return "questionnaire";
        case "Agreement":
          return "agreement";
        case "Document - Vaccine/PCR":
          return "vaccine_document";
        default:
          "";
      }
    },
    changeComplianceType(type) {
      if(type && type.id == "agreement") {
        this.form.agreementFormat = "text_manually";
        this.form.agreementTxt = "";
        if(this.form.content_type != "TEXT" ) this.removeFile();
      }
    },
    changeAgreementFormatVal(val) {
      // console.log('val', val);
      if (val === "text_manually") {
        this.form.content_type = "TEXT";
        this.form.agreementTxt = "";
      } else if (val === "upload_file") {
        this.form.content_type = "FILE";
        this.removeFile();
      }
      console.log('this.form.content_type', this.form.content_type);
      if(this.$route.name == "updateCompliance" && val === "upload_file" ){
        this.canChangeComplianceFormat(this.getComplianceDetails.id).then((res) =>{
          // console.log('res', res);
          if(!res.data) this.$bvModal.show("changeComplianceFormatModal");  
        })
      }
    

      // console.log('this.form.content_type', this.form.content_type);
    },

    uploadFile(e){
        this.uploadFileError = false;
        let selectedFile = e.target.files[0];
        if (!selectedFile) return;
        let reader = new FileReader();
        reader.readAsDataURL(selectedFile);
        reader.onload = () => {
        if ( selectedFile.size > 2097152) {
          this.uploadFileError = true;
          this.$refs.fileRefName.value = [];
          return
        } else if (selectedFile && this.validTypesFiles.includes(selectedFile.type)) {
          this.calculateFileType(selectedFile.type);
          this.form.fileName = selectedFile.name;
          this.form.attachment_url = selectedFile;
          this.form.filePreviewUrl = URL.createObjectURL(selectedFile);
          this.previewData = {file : this.form.filePreviewUrl, name: this.form.fileName.replace(/\.pdf$/i, ''), type: this.form.content_type};
        } else {
          this.uploadFileError = true;
          return 
        }
        };
        reader.onerror = (evt) => {
        console.error(evt);
        };
    },
    calculateFileType(val){
      if (val === "application/pdf") {
        this.form.content_type = "PDF";
      } else {
        this.form.content_type = "IMAGE";
      } 
    },
    removeFile() {
      this.uploadFileError = false;
      this.form.attachment_url = null;
      this.form.filePreviewUrl = null;
      this.form.fileName = "";
      this.form.content_type = "FILE";
      setTimeout(() => {
        this.$refs.fileRefName.value = [];
      },100)
      this.submitted = false;
    },
    showFilePreview() {
      this.$bvModal.show("complianceDetailsModal");
    },
    showPdfFilePreview() {
      window.open(this.form.filePreviewUrl, '_blank');
    },
    triggerFileInput() {
      this.$refs.fileRefName.click();
    },
    onSubmit() {  
      this.submitted = true;
      this.$v.$touch();
      // console.log('this.handleComplianceType()',this.handleComplianceType()); 
      if (
        this.$v.$invalid ||
        (!this.form.yesChecked && !this.form.noChecked) ||
        this.addedQuestioinsErr
      ) {
        return;
      } else {
        let entity = store.getters["authfack/currentEntity"];
        let questions =
          this.form.type.id == "questionnaire" || this.form.type.id == "agreement"
            ? [
                {
                  answers: [
                    {
                      desired: this.form.yesChecked,
                      text: this.form.yesStatement,
                      yesAnswer: true,
                    },
                    {
                      desired: this.form.noChecked,
                      text: this.form.noStatement,
                      yesAnswer: false,
                    },
                  ],
                  body:
                    this.form.type.id == "agreement"
                      ? this.form.agreementTxt
                      : this.form.questionInput,
                  type: this.form.type.id,
                  content_type: this.form.content_type,
                  attachment_url: this.form.attachment_url,
                },
              ]
            : [
                {
                  answers: [
                    {
                      desired: this.form.yesChecked,
                      text: this.vaccine.uploadedStatement,
                      yesAnswer: true,
                    },
                    {
                      desired: this.form.noChecked,
                      text: this.vaccine.notUploadedStatement,
                      yesAnswer: false,
                    },
                  ],
                  bind: this.vaccine.document_binding,
                  protocols: this.printProtocolsArr,
                  pcr: this.vaccine.pcr
                    ? { days: this.vaccine.validationDays }
                    : null,
                  type: this.form.type.id,
                  content_type: this.form.content_type,
                  attachment_url: this.form.attachment_url,
                },
              ];
        let answers2 = this.answers;
        if (answers2.length > 0) {
          for (let i = 0; i < answers2.length; i++) {
            questions.push({
              answers: [
                {
                  desired: answers2[i][1].desired,
                  text: answers2[i][1].text,
                  yesAnswer: true,
                },
                {
                  desired: answers2[i][2].desired,
                  text: answers2[i][2].text,
                  yesAnswer: false,
                },
              ],
              body: answers2[i][0].question,
              type: this.form.type.id,
              content_type: this.form.content_type,
              attachment_url: this.form.attachment_url,
            });
          }
        }

        console.log("questions", questions);
        let submittedForm = new FormData();
        if(this.form.type.id == "questionnaire" || this.form.type.id == "agreement"){
          submittedForm.append("name", this.form.name);
          submittedForm.append("entity_id", entity.id);
          submittedForm.append("type", this.form.type.id);
          
          for (let i = 0; i < questions.length; i++) {
            const element = questions[i];
            submittedForm.append(`questions[${i}][body]`, element.body && element.content_type == "TEXT" ? element.body : "");
            submittedForm.append(`questions[${i}][type]`, element.type);
            submittedForm.append(`questions[${i}][content_type]`, element.content_type ? element.content_type : "TEXT");
            submittedForm.append(`questions[${i}][attachment_url]`, element.attachment_url && (element.content_type == "IMAGE" || element.content_type == "PDF") ? element.attachment_url : "");
            for (let j = 0; j < element.answers.length; j++) {
              const answer = element.answers[j];
              submittedForm.append(`questions[${i}][answers][${j}][desired]`, answer.desired);
              submittedForm.append(`questions[${i}][answers][${j}][text]`, answer.text);
              submittedForm.append(`questions[${i}][answers][${j}][yesAnswer]`, answer.yesAnswer);
            }
          }
          // submittedForm.append("questions", JSON.stringify(questions));
        } else{
          submittedForm.append("entity_id", entity.id);
          submittedForm.append("name", this.form.name);
          submittedForm.append("type", this.form.type.id);
          submittedForm.append("data", JSON.stringify(questions));
          submittedForm.append("bind", this.vaccine.document_binding);
          if (this.vaccine.pcr) {
            submittedForm.append(
              "pcr",
              JSON.stringify({ days: this.vaccine.validationDays })
            );
          }
        }
          // (this.form.type.id == "questionnaire" || this.form.type.id == "agreement")
          //   ? {
          //       name: this.form.name,
          //       entity_id: entity.id,
          //       type: this.form.type.id,
          //       questions,
          //       constent_type: this.form.content_type,
          //       attachment_url: this.form.attachment_url,
          //     }
          //   : {
          //       entity_id: entity.id,
          //       name: this.form.name,
          //       type: this.form.type.id,
          //       data: questions,
          //       bind: this.vaccine.document_binding,
          //       pcr: this.vaccine.pcr
          //         ? { days: this.vaccine.validationDays }
          //         : null,
          //     };





        this.$route.name == "updateCompliance"
          ? this.updateComplianceAction({
              id: this.getComplianceDetails.id,
              form: submittedForm,
            })
          : this.createCompliance(submittedForm);
      }
    },
    writtenQuestions(questions) {
      this.answers.push(questions);
    },
    deleteQuestion(index) {
      this.answers.splice(index, 1);
    },
    getProtocolsValueOnUpdate(arr) {
      return (
        arr &&
        arr.length > 0 &&
        arr.map((protocol) => {
          switch (protocol) {
            case "nhs":
              return "NHS (Domestic/International)";
            case "eu":
              return "EU Digital COVID Certificate";
            case "shc":
              return "Smart Health Card (SHC)";
            case "nys":
              return "NYS Excelsior Pass & NYS Excelsior Pass Plus";
            default:
              return;
          }
        })
      );
    },
    setAddedQuestioinsErr(status) {
      this.addedQuestioinsErr = status;
    },
  },
  beforeMount() {
    this.$route.name == "updateCompliance" && this.complianceDetails(this.$route.params.id);
  },
};
</script>

<style lang="scss">
.protocols-multiselect.is-invalid{
  border : unset !important;
}
.gap-10 .form-row {
  gap: 10px
}
.bindingTo .custom-control {
  padding-inline-end: 1.5rem;
}
#createCompliance {
  li {
    list-style: none;
  }
  .quiz-btns-box {
    justify-content: center;
    margin-top: 30px;
    align-items: center;

    button {
      margin-inline-end: 15px;
      margin-bottom: 10px;
      text-transform: uppercase;
      margin: 0 auto;
      color: #103f5e;
      font-weight: 600;
      background: transparent;
      border: none;
    }
  }

  .quiz-container {
    margin-top: 24px;
    width: 100%;
    align-items: center;
    justify-content: space-between;

    .comp-checkbox {
      label.custom-control-label {
        &::before {
          border-radius: 5 !important;
        }
      }

      margin-inline-end: 20px;

      @media only screen and (max-width: 500px) {
        margin-inline-end: 15px;
      }
    }

    .comp-input-container {
      position: relative;
      width: 100%;

      label {
        top: -11px;
        inset-inline-start: 20px;
        position: absolute;
        background-color: #fff;
        padding: 0 10px;
        margin: 0;
        z-index: 10;
      }

      input {
        height: 36px;
        width: 100%;
        border: 1px solid #ced4da;
      }
    }
  }
  .card-title {
    font-size: 16px;
    font-weight: 500;
    text-transform: capitalize;
    letter-spacing: 0.15px;
  }
  .card-subtitle {
    color: #74788d;
    letter-spacing: 0.25px;
    line-height: 16px;
    font-size: 16px;
    margin-top: 0px;
    margin-inline-end: 10px;
    margin-bottom: 5px;
    margin-inline-start: 0px;
    text-transform: uppercase;
  }
  .form-width {
    padding: 24px;
    background: #fff;
    border-radius: 8px;
  }
  .form-width {
    @media only screen and (max-width: 900px) {
      width: 80%;
    }

    @media only screen and (max-width: 670px) {
      width: 100% !important;
    }
  }
  .card-form {
    width: 95%;
    margin: 0 auto;

    @media only screen and (max-width: 900px) {
      width: 80%;
    }

    @media only screen and (max-width: 670px) {
      width: 100%;
    }
  }
  .comp-subtitle {
    font-size: 14px;
  }
  .form-group input {
    width: 100%;
    height: 36px;
  }
  #agreement-txt {
    height: 130px;
    resize: none;
  }
  #desired-answer {
    width: 56px;
    height: 24px;
  }
  .submit-btn-container {
    margin-top: 40px;
    justify-content: center;
    text-align: center;
  }
  .secondary-title {
    color: #103f5e;
    text-transform: uppercase;
    font-weight: 500;
    font-size: 14px;
    line-height: 12px;
    letter-spacing: 0.75px;
    margin-top: 30px;
    margin-inline-end: 5px;
    margin-bottom: 40px;
    margin-inline-start: 0;
  }
  .compliance-ques-table {
    word-break: break-all;
    width: 100%;
    margin-inline-start: 10px;

    @media only screen and (max-width: 670px) {
      margin-inline-start: 0px;
      display: flex;
      flex-direction: column !important;
    }

    tr {
      border-bottom: 1px solid #f6f6f6;
      width: 100%;
    }

    td {
      padding: 15px 0;
    }

    th,
    .th {
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: 0.25px;
      padding-bottom: 10px;
      text-transform: capitalize;
    }
  }
  .compliance-ques-table tr:last-child {
    border-bottom: none !important;
  }
  .form-group label {
    font-size: 14px;
  }
  .individual-quiz {
    @media only screen and (max-width: 670px) {
      flex-direction: column !important;
      padding: 10px;
    }

    span {
      @media only screen and (max-width: 670px) {
        margin-bottom: 9px;
      }
    }
  }
  .question-text {
    text-transform: capitalize;
    color: #343a40;
  }
  .question-preview {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.6);
  }
  .show-desktop {
    @media only screen and (max-width: 670px) {
      display: none;
    }
  }

  .show-mobile {
    @media only screen and (min-width: 670px) {
      display: none;
    }
  }

  .checkbox-input {
    max-width: 40px;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  .card-body {
    @media only screen and (max-width: 670px) {
      padding: 20px 14px !important;
    }
  }
  .err-font {
    font-size: 0.8rem;
  }
  .cursor-not-allowed{
    cursor: not-allowed;
  }


  .admin-answer {
    margin-bottom: 8px;
  }

  .remove-image-times{
    cursor: pointer;
    margin-top: -10px;
    margin-left: -3px;
  }

  .remove-pdf-times{
    cursor: pointer;
    margin-top: -5px;
    margin-left: -3px;
  }

  .upload-file-error{
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0.25px;
    color: #F46A6A;
  }
  .thumbnail-image{
    width: auto;
    height: 80px;
  }

  .pdf-icon {
    height: 80px;
  }

  //.pdf-icon:lang(ar) {
    //transform: scaleX(-1);
  //}

  .no-file-choosen-btn {
    height: 28px;
    border: 1px solid #ced4da;
    padding: 3px 8px;
    border-radius: .25em;
    background-color: #fff;
    cursor: pointer;
    content: 'Choose fileeee';
  }

  label.no-file-choosen-text{
    margin-bottom: 0px !important;
    margin-left: 8px !important;
  }

  label.no-file-choosen-text:lang(ar) {
    margin-right: 8px !important;
  }

  input[type=file]::file-selector-button {
    border: 1px solid #ced4da;
    padding: 3px 8px;
    border-radius: .25em;
    background-color: #fff;
    cursor: pointer;
    content: 'Choose fileeee';
  }
    input[type=file]::placeholder {
    content: 'Choose fileeee';
  }

  .upload-file-compliance:lang(ar) .custom-file-label::after{
    left:0;
    right: unset;
    border-left: unset;
    border-right: inherit;
    content:'آختر الملف'
  }

  .upload-file-compliance:lang(es) .custom-file-label::after{
    content:'Elegir archivo'
  }

  .upload-file-compliance:lang(en) .custom-file-label::after{
    content:'Choose file'
  }
  .custom-file {
    width:35%
  }

  .v-radio {
    height: 44px !important; 
  }

  .upload-file-note {
    margin-top: -4px;
    color: #787878;
  }
  .upload-file-note:lang(ar) {
    margin-right: 27px !important;
  }
}
</style>
